export interface CalendarMeeting { id: string; title: string; roomName: string; startsAt: string; creatorName: string }
export function calendarMeetingUrl(id: string): string { return `https://app.vorbello.eu/?meet=${encodeURIComponent(id)}`; }
export function calendarTimes(meeting: CalendarMeeting): { start: Date; end: Date } {
  const start = new Date(meeting.startsAt);
  if (!Number.isFinite(start.getTime())) throw new Error('Data întâlnirii este invalidă.');
  return { start, end: new Date(start.getTime() + 60 * 60 * 1000) };
}
export function calendarUtc(date: Date): string { return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z'); }
export function meetingIcs(meeting: CalendarMeeting, now = new Date(), invitationUrl = calendarMeetingUrl(meeting.id)): string {
  const escape = (s: string) => s.replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
  const { start, end } = calendarTimes(meeting);
  const url = invitationUrl;
  return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Vorbello//Meeting//RO','CALSCALE:GREGORIAN','BEGIN:VEVENT',
    `UID:${escape(meeting.id)}@app.vorbello.eu`,`DTSTAMP:${calendarUtc(now)}`,`DTSTART:${calendarUtc(start)}`,`DTEND:${calendarUtc(end)}`,
    `SUMMARY:${escape(meeting.title)}`,`LOCATION:${escape(meeting.roomName)}`,`DESCRIPTION:${escape(`Link: ${url}\nOrganizator: ${meeting.creatorName}`)}`,
    `URL:${url}`,'END:VEVENT','END:VCALENDAR',''].join('\r\n');
}
